var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wordstarwrapper",staticStyle:{"width":"100$","min-height":"300px"}},[_c('canvas',{ref:"wordstar"})])}
var staticRenderFns = []

export { render, staticRenderFns }